<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar o Módulo(Edifício) <b>{{this.entry.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
// import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyEntry: function() {
    //  this.destroyServerEntry(this.entry);
    this.$set(this.entry, "_destroy", true);
    this.$emit("entry-destroyed", this.entry);
    // console.log("delete", this.entry);
    // this.$refs.baseDelete.closeDialog();
   },
 }
}
</script>

<style scoped></style>